"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var compat_1 = require("preact/compat");
var BaseModal = function (_a) {
    var open = _a.open, children = _a.children;
    var modifier = open ? 'preact-modal--open' : '';
    return (0, preact_1.h)("div", { class: "preact-modal ".concat(modifier) }, children);
};
exports.default = (0, compat_1.memo)(BaseModal);
